import { sha256 } from '../crypto/sha256';

/** RFC 6962 §2.1: leaves and interior nodes use distinct domain-separation prefixes. */
const LEAF_PREFIX = new Uint8Array([0x00]);
const NODE_PREFIX = new Uint8Array([0x01]);

export const HASH_SIZE = 32;

export const leafHash = (leaf: Uint8Array): Promise<Uint8Array> => sha256(LEAF_PREFIX, leaf);
export const nodeHash = (left: Uint8Array, right: Uint8Array): Promise<Uint8Array> => sha256(NODE_PREFIX, left, right);
/** MTH of the empty tree is SHA-256 of the empty string. */
export const emptyRoot = (): Promise<Uint8Array> => sha256(new Uint8Array(0));
